<template>
  <section class="py-9 tablet:py-20" :class="backgroundClass">
    <div class="container-wrap">
      <h2 class="text-h2 mb-10 tablet:line-clamp-2">
        {{ title }}
      </h2>
      <TheRichText
        v-if="descriptionHtml || description"
        class="mb-10 w-full text-sm leading-6 text-gray-700 tablet:line-clamp-7 tablet:text-base"
        :text="descriptionHtml || description"
        :is-html="!!descriptionHtml"
      />

      <TheTabs
        v-if="contextTabs.length > 1"
        v-model="current"
        :tabs="contextTabs"
      />
    </div>

    <div class="container-mobile-extend-wrap">
      <div
        v-for="(tabItem, index) in tabs"
        v-show="current === index"
        :key="index"
      >
        <CarouselBasic :carousel-list="tabItem.items">
          <template #card="{ item }">
            <CardLogo01
              :title="item.name"
              :description="item.description"
              :logo="item.logo"
              :tags="item.tags"
              :has-shadow="false"
            />
          </template>
        </CarouselBasic>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  /**
   * @see https://www.figma.com/design/QJ3ZvEbUHI9xI11iudYf8U/Advantech-WISE-Library?node-id=13391-43702&t=89PIFDiQEC4zcSbf-0
   */

  interface IItem {
    name: string;
    description: string;
    logo?: string;
    tags: string[];
  }

  interface ITab {
    tabName: string;
    items: IItem[];
  }

  interface IProps {
    title: string;
    description?: string;
    descriptionHtml?: string;
    tabs: ITab[];
    theme?: TTheme;
  }

  const props = withDefaults(defineProps<IProps>(), {
    description: undefined,
    descriptionHtml: undefined,
    theme: 'blue',
  });

  const current = ref<number>(0);

  const contextTabs = computed((): string[] =>
    props.tabs.map((item) => item.tabName)
  );

  const backgroundClass = computed((): string => {
    switch (props.theme) {
      case 'green':
        return 'bg-gradient-to-t from-green-150 to-white';
      case 'cyan':
        return 'bg-gradient-to-t from-cyan-150 to-white';
      case 'purple':
        return 'bg-gradient-to-t from-purple-150 to-white';
      case 'yellow':
        return 'bg-gradient-to-t from-yellow-150 to-white';
      default:
        return 'bg-gradient-to-t from-blue-150 to-white';
    }
  });

  export type { IItem, ITab };
</script>
